var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-expansion-panel',{staticClass:"expansion-container"},[_c('v-expansion-panel-header',{class:['px-0', 'small-icon']},[_c('div',{staticClass:"panel-title"},[_vm._v(_vm._s(_vm.title))])]),_c('v-expansion-panel-content',{staticClass:"px-0"},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }